import React from 'react';
import './Footer.css';
import cv from '../assets/Md_Ruman_Islam_CV.pdf';
import { FaGithub, FaGitlab, FaGoogleScholar, FaLinkedin } from 'react-icons/fa6';
import { ImProfile } from 'react-icons/im';

const FOOTER_LINKS = [
  { label: 'LinkedIn', href: 'https://linkedin.com/in/ruman-i', icon: FaLinkedin },
  { label: 'GitHub', href: 'https://github.com/ruman23', icon: FaGithub },
  { label: 'GitLab', href: 'https://gitlab.com/ruman23', icon: FaGitlab },
  { label: 'Google Scholar', href: 'https://scholar.google.com/citations?user=cJZu7JgAAAAJ&hl=en&authuser=1', icon: FaGoogleScholar },
  { label: 'CV', href: cv, icon: ImProfile },
];

function Footer() {
  return (
    <footer className="footer site-section">
      <div className="site-section-inner footer-inner">
        <div className="footer-copy">
          <p>Md Ruman Islam</p>
          <span>AI for 6G networks, digital twins, and autonomous cyber-physical systems.</span>
        </div>

        <div className="footer-links">
          {FOOTER_LINKS.map(({ label, href, icon: Icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              title={label}
            >
              <Icon />
            </a>
          ))}
        </div>

        <p className="footer-meta">© 2026 Md Ruman Islam</p>
      </div>
    </footer>
  );
}

export default Footer;
